import React from "react";
import clsx from "clsx";

export interface TabOption {
    key: string;
    label: string;
}

interface TabProps {
    label: string;
    active: boolean;
    onClick: () => void;
}

const Tab: React.FC<TabProps> = ({ label, active, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={clsx(
                "border transition-all duration-100 ease-in-out rounded-[100px] px-[24px] py-[8px] text-[14px] font-medium text-black dark:text-white",
                active ? "border-black dark:border-white" : "border-black/6 dark:border-white/20"
            )}
        >
            <span>{label}</span>
        </button>
    );
};

interface TabsProps {
    tabs: TabOption[];
    activeTab: string;
    onTabChange: (tabKey: string) => void;
    className?: string;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, className = "" }) => {
    return (
        <div className={clsx("mb-6", className)}>
            <nav className="-mb-px flex space-x-2">
                <div className="flex gap-[8px]">
                    {tabs.map((tab) => (
                        <Tab
                            key={tab.key}
                            label={tab.label}
                            active={activeTab === tab.key}
                            onClick={() => onTabChange(tab.key)}
                        />
                    ))}
                </div>
            </nav>
        </div>
    );
};

export default Tabs;
